import { useId } from 'react';

import { SettingsCard } from 'design-system';

import { TERMS_VERSION } from '@/config/constants';
import { DateTextVariants, useDateText, useUserDetails } from '@/features/_shared/user';
import Button from '@/shared/ui/primitives/Button';

const Terms = () => {
  const titleId = useId();
  const { terms } = useUserDetails();
  const { formatDateString } = useDateText();

  return (
    <SettingsCard
      aria-labelledby={titleId}
      title={
        <span className='flex flex-wrap items-baseline gap-x-5 gap-y-1'>
          <span
            id={titleId}
            className='text-base tracking-normal text-foreground normal-case'
          >
            Terms &amp; Conditions
          </span>
          <span className='text-sm font-semibold tracking-normal text-gx-muted normal-case'>
            Version {TERMS_VERSION}
          </span>
        </span>
      }
      action={
        <span className='flex flex-wrap items-center justify-end gap-x-7 gap-y-2'>
          <span className='text-sm font-semibold text-gx-muted'>
            {terms ? <>Signed {formatDateString(terms, DateTextVariants.FULL)}</> : 'Not Signed'}
          </span>
          <Button
            color='secondary'
            component='a'
            download={`terms_${TERMS_VERSION}.pdf`}
            href='/terms.pdf'
            size='small'
            target='_blank'
            variant='text'
          >
            Download
          </Button>
        </span>
      }
    />
  );
};

export default Terms;
